// extracted by mini-css-extract-plugin
module.exports = {"quote":"Quote_quote__58Djh","slides":"Quote_slides__fFqFh"};